import { useState } from "react";

const faqs = [
  {
    question: "大满贯APP支持哪些安卓手机型号？",
    answer: "大满贯APP支持所有搭载Android 8.0及以上系统的智能手机，包括华为、小米、OPPO、vivo、三星、荣耀等主流品牌全系列机型。我们针对不同品牌进行了专项适配优化。",
  },
  {
    question: "如何下载并安装大满贯APP？",
    answer: "访问大满贯官方网站，点击首页「立即下载」按钮即可获取最新版APK安装包。下载完成后，打开APK文件按提示完成安装。部分手机需要开启「允许安装未知来源应用」权限。",
  },
  {
    question: "大满贯APP是免费的吗？",
    answer: "大满贯APP基础功能完全免费，包括赛事直播、实时数据、基础分析等功能。我们也提供高级会员服务，解锁更专业的数据分析工具和无广告观赛体验。",
  },
  {
    question: "大满贯APP的数据分析准确度如何？",
    answer: "大满贯的数据来自官方赛事数据源，经过多重校验确保准确性。我们的AI预测模型基于百万级历史数据训练，预测准确率稳定在75%以上，获得了广大用户和专业分析师的一致认可。",
  },
  {
    question: "安装时提示「解析包错误」怎么办？",
    answer: "请检查以下几点：1）确认APK文件下载完整，建议重新下载；2）确认手机系统版本为Android 8.0及以上；3）清理手机存储空间确保有足够的安装空间；4）检查APK文件是否被安全软件拦截。",
  },
  {
    question: "更新版本后之前的收藏和历史会丢失吗？",
    answer: "不会。您的所有数据都存储在云端服务器上，与APP版本无关。更新到最新版后，登录同一账号即可恢复所有数据，包括收藏内容、观看历史和个性化设置。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <section className="w-full py-16 md:py-24 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-4">
              常见问题
            </h2>
            <p className="text-foreground-500 text-base">关于大满贯APP，你想知道的都在这里</p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-50 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-300 flex-shrink-0 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`px-6 overflow-hidden transition-all duration-300 ${
                    openIndex === index ? "pb-4 max-h-96" : "max-h-0"
                  }`}
                >
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}